import './App.css';
import React  from "react";
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from './components/pages/Contactus';
import Aboutus from './components/pages/Aboutus';
import BasmatiRice from './components/pages/BasmatiRice';
import Enquiry from './components/pages/Enquiry';
import Clothpage from './components/pages/Clothpage';
import Miniket from './components/pages/Miniket';
import Ginger from './components/pages/Ginger';
import Handcraft from './components/pages/Handcraft';
import Canepage from './components/pages/Canepage';
import Dhaniyapage from './components/pages/Dhaniyapage';
import Dairy from './components/pages/Dairy';
import Masoordal from './components/pages/Masoordal';
import Director from './components/pages/Director';
import Matirputul from './components/pages/Matirputul';
import Sarbhaja from './components/pages/Sarbhaja';
import Gallerypage from './components/pages/Gallerypage';

function App() {
  return (
    <Router>
     
  <div>
  
    <Routes>
    <Route axact path="/" element={<Home/>}/>
    <Route axact path="/contact-us" element={<Contactus/>}/>
    <Route axact path="/about-us" element={<Aboutus/>}/>
    <Route axact path="/Basmati-rice" element={<BasmatiRice/>}/>
    <Route axact path="/enquiry" element={<Enquiry/>}/>
    <Route axact path="/garments" element={<Clothpage/>}/>
    <Route axact path="/miniket-rice" element={<Miniket/>}/>
    <Route axact path="/Ginger" element={<Ginger/>}/>
    <Route axact path="/handcraft" element={<Handcraft/>}/>
    <Route axact path="/cane-furniture" element={<Canepage/>}/>
    <Route axact path="/dhaniya-seed" element={<Dhaniyapage/>}/>
    <Route axact path="/dairy" element={<Dairy/>}/>
    <Route axact path="/director" element={<Director/>}/>
    <Route axact path="/Masoordal" element={<Masoordal/>}/>
    <Route axact path="/krishnagar_famous-Matir-putul" element={<Matirputul/>}/>
    <Route axact path="/sarbhja-sarpuria" element={<Sarbhaja/>}/>
        <Route axact path="/Gallery" element={<Gallerypage/>}/>
    </Routes>
    <Footer/>
  
    </div>
 
    </Router>
  );
}

export default App;
